<ppl-box-container-with-title [small]="true"
                              title="Your email is now verified"
                              i18n-title="@@Your_email_is_now_verified"
                              description="Continue to login screen"
                              i18n-description="@@Continue_to_login_screen">
  <div class="buttons">
    <button pplButton
            class="submit-button"
            (click)="onLogin()"
            i18n="@@Log_in">Log in</button>
  </div>
</ppl-box-container-with-title>
